const hostname = window.location.hostname;
const economicAppSecretToken = 'HmhVx7UHxlOUkh7fNCovgHs4fwxB6l9Rp5AHEwzVbmw';
const economicAgreementToken = 'Az03klvpIMB1JJUfBSl23eBhNgxBh2wURt8zj8zBemo';
const appBarColorCode = '#a30000';
const linkedinClientId = '77hsh28kwvejg8'; // Moved from .env

const environmentConfig = {
    'devcrm.f5.dk': {
        ERP_BASE_URL: 'https://deverp.f5.dk',
        CRM_API_BASE_URL: 'https://deverp2.f5.dk',
        ECONOMIC_APP_SECRET_TOKEN: economicAppSecretToken,
        ECONOMIC_APP_AGREEMENT_TOKEN: economicAgreementToken,
        APP_BAR_COLOR_CODE: appBarColorCode,
        LINKEDIN_CLIENT_ID: linkedinClientId,
    },
    "qacrm.f5.dk": {
        ERP_BASE_URL: 'https://qaerp.f5.dk',
        CRM_API_BASE_URL: 'https://qaerp2.f5.dk',
        ECONOMIC_APP_SECRET_TOKEN: economicAppSecretToken,
        ECONOMIC_APP_AGREEMENT_TOKEN: economicAgreementToken,
        APP_BAR_COLOR_CODE: appBarColorCode,
        LINKEDIN_CLIENT_ID: linkedinClientId,
    },
    "uatcrm.f5.dk": {
        ERP_BASE_URL: 'https://uaterp.f5.dk',
        CRM_API_BASE_URL: 'https://uaterp2.f5.dk',
        ECONOMIC_APP_SECRET_TOKEN: economicAppSecretToken,
        ECONOMIC_APP_AGREEMENT_TOKEN: economicAgreementToken,
        APP_BAR_COLOR_CODE: appBarColorCode,
        LINKEDIN_CLIENT_ID: linkedinClientId,
    },
    "crm.f5.dk": {
        ERP_BASE_URL: 'https://erp.f5.dk',
        CRM_API_BASE_URL: 'https://erp2.f5.dk',
        ECONOMIC_APP_SECRET_TOKEN: 'hBqD72bH14vlQaKboFKmtQEIVM8oSPE4ao6ITQj4KuQ',
        ECONOMIC_APP_AGREEMENT_TOKEN: 'pD2oncfg9FLcjcZGXshycj9sMf2EbThMzl3I7rE3hFo1',
        APP_BAR_COLOR_CODE: '#002ea7',
        LINKEDIN_CLIENT_ID: linkedinClientId,
    },
    'default': {
        ERP_BASE_URL: 'http://f5.erp.dk',
        CRM_API_BASE_URL: 'http://f5.erp2.dk',
        ECONOMIC_APP_SECRET_TOKEN: economicAppSecretToken,
        ECONOMIC_APP_AGREEMENT_TOKEN: economicAgreementToken,
        APP_BAR_COLOR_CODE: appBarColorCode,
        LINKEDIN_CLIENT_ID: linkedinClientId,
    }
};

const config = environmentConfig[hostname] || environmentConfig['default'];

export default config;